'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MediaoceanPrisma = (_temp = _class = function (_SvgIcon) {
  _inherits(MediaoceanPrisma, _SvgIcon);

  function MediaoceanPrisma() {
    _classCallCheck(this, MediaoceanPrisma);

    return _possibleConstructorReturn(this, (MediaoceanPrisma.__proto__ || Object.getPrototypeOf(MediaoceanPrisma)).apply(this, arguments));
  }

  _createClass(MediaoceanPrisma, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            d: 'M24.36,21.85l.17,0c1.89-.86,3.61-2,5.43-3a8.2,8.2,0,0,0,2.17-1.37c.17-.1.14-.27.14-.42V9c0-.15,0-.32-.13-.43C27.43,5.89,22.73,3.17,18,.49a2.39,2.39,0,0,0-2.37,0C13.5,1.69,11.4,2.94,9.28,4.17c-.14.08-.13.22-.13.35,0,2.48,0,5,0,7.45V39.54c2.29-1.33,4.47-2.55,6.6-3.85a2.29,2.29,0,0,0,1.07-1.95c0-2.45,0-4.91,0-7.36l.08-.15c1.78-1,3.58-2,5.35-3.05A8,8,0,0,0,24.36,21.85Z',
            fill: '#fefefe'
          }),
          _react2['default'].createElement('path', {
            d: 'M9.17,30.66V22.89a4.1,4.1,0,0,1,2.13-2.28c1.78-1,3.61-1.92,5.29-3.09.11-.06.11-.11,0-.16-1.57-.91-3.12-1.84-4.69-2.74C10.75,14,9.56,13.4,9.17,12c0-2.48,0-5,0-7.45,0-.13,0-.27.13-.35,1.34,1,2.9,1.68,4.31,2.58a16.59,16.59,0,0,1,3.25,2q0,4.29.05,8.58a.15.15,0,0,0,0,.13v8.73l-.08.15c-.29.14-.58.26-.85.41Z',
            fill: '#009387'
          }),
          _react2['default'].createElement('path', {
            d: 'M16.84,8.79a16.59,16.59,0,0,0-3.25-2c-1.41-.9-3-1.56-4.31-2.58C11.4,2.94,13.5,1.69,15.64.5A2.39,2.39,0,0,1,18,.49c4.72,2.68,9.42,5.4,14.13,8.11-1.09.83-2.35,1.38-3.5,2.1-1.31.81-2.73,1.44-4,2.36h-.15l-.15-.12L17.48,9C17.29,8.88,17.1,8.69,16.84,8.79Z',
            fill: '#01b1ad'
          }),
          _react2['default'].createElement('path', {
            d: 'M9.17,30.66,16,26.79c.27-.15.56-.27.85-.41,0,2.45.06,4.91,0,7.36a2.29,2.29,0,0,1-1.07,1.95c-2.13,1.3-4.31,2.52-6.6,3.85Z',
            fill: '#05b1ac'
          }),
          _react2['default'].createElement('path', {
            d: 'M9.17,12c.39,1.43,1.58,2,2.73,2.65,1.57.9,3.12,1.83,4.69,2.74v.16c-1.68,1.17-3.51,2.09-5.29,3.09a4.1,4.1,0,0,0-2.13,2.28Z',
            fill: '#01b1ad'
          }),
          _react2['default'].createElement('path', {
            d: 'M24.51,13.06h.15c.27.16.53.34.8.49l6.67,3.86A8.2,8.2,0,0,1,30,18.78c-1.82,1-3.54,2.17-5.43,3C24.52,18.89,24.52,16,24.51,13.06Z',
            fill: '#d2d3c6'
          }),
          _react2['default'].createElement('path', {
            d: 'M32.13,17.41l-6.67-3.86c-.27-.15-.53-.33-.8-.49,1.25-.92,2.67-1.55,4-2.36,1.15-.72,2.41-1.27,3.5-2.1.17.11.13.28.13.43v8C32.27,17.14,32.3,17.31,32.13,17.41Z',
            fill: '#009387'
          }),
          _react2['default'].createElement('path', {
            d: 'M16.9,26.23q0-4.36,0-8.73c1.38.77,2.77,1.52,4.12,2.33a29.19,29.19,0,0,1,3.35,2,8,8,0,0,1-2.11,1.33C20.48,24.21,18.68,25.21,16.9,26.23Z',
            fill: '#d2d3c6'
          }),
          _react2['default'].createElement('path', {
            d: 'M24.36,21.85a29.19,29.19,0,0,0-3.35-2c-1.35-.81-2.74-1.56-4.12-2.33a.15.15,0,0,1,0-.13c2-1.12,4-2.22,6-3.37.53-.3,1.2-.43,1.51-1.06l.15.12c0,2.91,0,5.83,0,8.75Z',
            fill: '#b0b09b'
          }),
          _react2['default'].createElement('path', {
            d: 'M24.36,12.94c-.31.63-1,.76-1.51,1.06-2,1.15-4,2.25-6,3.37q0-4.29-.05-8.58c.26-.1.45.09.64.2Z',
            fill: '#d2d3c6'
          }),
          _react2['default'].createElement('path', {
            d: 'M16.59,17.52v-.16C16.7,17.41,16.7,17.46,16.59,17.52Z',
            fill: '#05b1ac'
          })
        );
      }

      return render;
    }()
  }]);

  return MediaoceanPrisma;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40.17 40.04'
}, _temp);
exports['default'] = MediaoceanPrisma;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/MediaoceanPrisma.js
// module id = 1384
// module chunks = 32